/**
*
* LoginPage
* @todo: need to move the Login component to the POP_UP
*/

import React, { PureComponent, Fragment } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { func, bool, shape, string } from 'prop-types';
import { Input, Button, Form } from 'antd';
import { withRouter, Link } from 'react-router-dom';

import StyledLogin from './StyledLogin';
import { select_LoginJS, selectLoginForm, selectOtpSent, selectOtpSubmit, selectSetPasswordSubmit, selectIsOtpRequested } from './selectors';
import { selectLoggedIn } from '../HeaderContainer/selectors';
import {
  login, changeLoginForm, changeSignUpForm, signUp, changeForgotForm, forgotSubmit, changeSetPasswordForm, setPasswordSubmit,
  signUpOtpSubmitForm, sendSignUpOtp, verifyUserMobileNumber, saveProfileChange,
} from './actions';
import Radio from '../../components/Radio';
import { utils, validations, eventTracking, constants, validationRules } from '../../devUtils';
import ValidationErrors from '../../components/ValidationErrors';
import Alert from '../../components/Alert';
import FloatingLabel from '../../components/FloatingLabel';
import { MANDATORYFIELDS_SIGNUP, MANDATORYFIELDS_FORGOT_PASSWORD } from './constants';
// import RecaptchaWrapper from '../../components/Recaptcha';

class LoginPage extends PureComponent {
  constructor(props) {
    super(props);
    const { apiResonse: { api }, apiResonse, signUpform: { name = '', phone = '', email = '' } } = props;
    this.state = {
      isLoginClicked: api !== 'SIGNUP' && true,
      showLogin: props.isShowLogin ? props.isShowLogin : true,
      isForgotPasswordClicked: false,
      otpSend: false,
      phoneNumber: '',
      isEmailClicked: true,
      isShowValidation: false,
      apiResonse,
      signUpOtp: '',
      autoSignUpDetails: {},
      captchaKey: '',
    };
    this.stateLessKeys = {
      otpVerificationForm: {},
      forgotActionStatus: 'intial',
      set_Password: {},
      forgot_Password: {},
      forgotMobileSubmit: false,
      autoSignUp: {},
    };
    this.validators = validations;
    this.onTabClick = this.onTabClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.storePhoneNumber = this.storePhoneNumber.bind(this);
    this.resendOTP = this.resendOTP.bind(this);
    this.handleChildActions = this.handleChildActions.bind(this);
    this.handleVerifyOtp = this.handleVerifyOtp.bind(this);
    this.onForgotSubmitAction = this.onForgotSubmitAction.bind(this);
    this.resendSignUpOtp = this.resendSignUpOtp.bind(this);
    this.updateAutoSignupDetails = this.updateAutoSignupDetails.bind(this);
    this.handleAutosignupDetails = this.handleAutosignupDetails.bind(this);
    this._onSignUp = this._onSignUp.bind(this);
    this._onForgotSubmit = this._onForgotSubmit.bind(this);
    this._onSetPassowrdSubmit = this._onSetPassowrdSubmit.bind(this);
    this._updateValidators = this._updateValidators.bind(this);
    this._validateCnfrmPass = this._validateCnfrmPass.bind(this);
    this._onLogin = this._onLogin.bind(this);
    this._onChangeSignUpOtp = this._onChangeSignUpOtp.bind(this);
    this.triggerEventTracking = this.triggerEventTracking.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.onRecaptchaValidation = this.onRecaptchaValidation.bind(this);
    if (name && email && phone) {
      this._updateValidators('name', name);
      this._updateValidators('email', email);
      this._updateValidators('phone', phone);
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyPress);
  }

  componentWillReceiveProps(nextProps) {
    const { isOtpSent,
      otpRequested,
      apiResonse: { api },
      apiResonse,
      isSetPasswordSubmit,
      isOtpSubmit,
    } = nextProps;
    if (!utils.isEqual(this.props.isOtpSent, nextProps.isOtpSent) || api === 'OTP' || api === 'FORGOT_OTP' || api === 'AUTO_SIGNUP' || api === 'SIGNUP') { /** @arg api handled in actions case if OTP is submitted again */
      // this.setState({ otpRequested, showLogin: false });
      if ((api === 'SIGNUP' || api === 'AUTO_SIGNUP') && nextProps.isOtpSent) {
        this.setState({ otpRequested, showLogin: false });
      } else {
        this.setState({ otpRequested });
      }
      if (this.stateLessKeys.forgotMobileSubmit) {
        if (isOtpSent) {
          this.stateLessKeys.forgotActionStatus = 'otpSubmit';
        }
        this.setState({ otpSend: isOtpSent, apiResonse });
      }
    }
    if (!utils.isEqual(this.props.isOtpSubmit, isOtpSubmit)) {
      this.setState({ otpSend: false, isForgotPasswordClicked: false, showLogin: true, apiResonse });
      this.stateLessKeys.forgotActionStatus = 'intial';
      this.stateLessKeys.forgot_Password = {};
      this.onTabClick('login');
    }
    if (!utils.isEqual(this.props.isSetPasswordSubmit, isSetPasswordSubmit)) {
      this.setState({ otpSend: false, isForgotPasswordClicked: false, showLogin: true, apiResonse });
      this.stateLessKeys.set_Password = {};
      this.onTabClick('login', apiResonse);
    }
    if (!utils.isEqual(this.props.apiResonse, nextProps.apiResonse)) {
      if (apiResonse.msg_type === 'success') {
        this.validators = utils.resetValidators(this.validators);
        this.setState({ autoSignUpDetails: {} });
      }
      this.setState({ apiResonse });
    }
  }

  componentWillUnmount() {
    this.validators = utils.resetValidators(this.validators);
    document.removeEventListener('keydown', this.handleKeyPress);
  }

  onTabClick(type, apiResonse) {
    let { isLoginClicked } = this.state;
    if (type === 'login') {
      isLoginClicked = true;
    } else {
      isLoginClicked = false;
    }
    if (apiResonse && apiResonse.api === 'SET PASSWORD') {
      this.setState({ isLoginClicked, isShowValidation: false });
    } else {
      this.setState({ isLoginClicked, apiResonse: {}, isShowValidation: false, phoneNumber: '', otpSend: false });
    }
    this.validators = utils.resetValidators(this.validators);
    this.props.onChangeSignUpForm('name', '');
    this.props.onChangeSignUpForm('phone', '');
  }

  onForgotSubmitAction() {
    // if (evt && evt.preventDefault) { evt.preventDefault(); }
    const { forgotActionStatus } = this.stateLessKeys;
    this.props.forgotSubmit(forgotActionStatus);
  }

  onRecaptchaValidation(response) {
    this.setState({ captchaKey: response, isShowValidationRecaptcha: false });
  }

  _onForgotSubmit() {
    // evt.preventDefault();
    const { otpSend } = this.state;
    const man_fileds = otpSend ? MANDATORYFIELDS_FORGOT_PASSWORD : ['phone'];
    if (utils.isFieldRequired(this.validators, man_fileds)) {
      this.setState({ isShowValidation: true });
    } else {
      this.stateLessKeys.forgotMobileSubmit = true;
      this.setState({ isShowValidation: false });
      this.onForgotSubmitAction();
    }
  }

  handleKeyPress(event) {
    if (event.keyCode === 13) {
      const { isLoginClicked, showLogin } = this.state;
      if (showLogin && isLoginClicked) {
        this._onLogin();
      } else if (showLogin && !isLoginClicked) {
        this._onSignUp();
      }
    }
  }

  storePhoneNumber(event) {
    this.setState({ phoneNumber: event.target.value });
  }

  handleChange(type) {
    const { isForgotPasswordClicked, showLogin } = this.state;
    if (type === 'forgot_pass') {
      if (showLogin) {
        this.setState({ showLogin: !showLogin, apiResonse: {} });
      }
      if (!isForgotPasswordClicked) {
        this.setState({ isForgotPasswordClicked: !isForgotPasswordClicked, phoneNumber: '', apiResonse: {} });
      }
    } else if (type === 'set_pass') {
      if (showLogin) {
        this.setState({ showLogin: !showLogin, apiResonse: {} });
      }
      if (isForgotPasswordClicked) {
        this.setState({ isForgotPasswordClicked: !isForgotPasswordClicked, phoneNumber: '', apiResonse: {} });
      }
    } else if (type === 'login' || type === 'signup') {
      this.makeLoginActive(type);
    }
  }

  resendOTP() {
    this.stateLessKeys.forgotActionStatus = 'resend';
    this.stateLessKeys.forgot_Password = {};
    this.onForgotSubmitAction();
  }

  /**
   * @todo validate CASE-2 and comment the given code
   */
  handleChildActions(key, id) {
    const { isEmailClicked } = this.state;
    if (id === 'email') {
      if (!isEmailClicked) {
        this.setState({ isEmailClicked: !isEmailClicked });
      }
    } else if (id === 'phone') {
      if (isEmailClicked) {
        this.setState({ isEmailClicked: !isEmailClicked });
      }
    }
    // CASE-2
    // if (id === 'email') {
    //   this.setState({ isEmailClicked: true });
    // } else if (id === 'phone') {
    //   this.setState({ isEmailClicked: false });
    // }
  }

  makeLoginActive(type) {
    this.stateLessKeys = { otpVerificationForm: {}, forgotActionStatus: 'intial', set_Password: {}, forgot_Password: {}, forgotMobileSubmit: false };
    this.setState({ otpSend: false });
    const { isForgotPasswordClicked, showLogin } = this.state;
    if (!showLogin) {
      this.setState({ showLogin: !showLogin });
    }
    if (isForgotPasswordClicked) {
      this.setState({ isForgotPasswordClicked: !isForgotPasswordClicked });
    }
    this.onTabClick(type);
  }

  handleVerifyOtp() {
    const { otpVerificationForm } = this.stateLessKeys;
    if (utils.isFieldRequired(this.validators, ['otp'])) {
      this.setState({ isShowValidation: true });
    } else {
      this.setState({ isShowValidation: false });
      otpVerificationForm.data.otp = this.state.signUpOtp;
      this.props.onSignUpOtpSubmitForm(otpVerificationForm);
    }
  }

  resendSignUpOtp(type) {
    const { response: { token, device_id } } = this.state.otpRequested;
    this.setState({ isShowValidation: false });
    if (type) {
      const { autoSignUp: { phone } } = this.stateLessKeys;
      this.props.onReSendSignUpOtp({ phone, token, device_id });
    } else {
      const { response: { user: { phone } } } = this.state.otpRequested;
      this.props.onReSendSignUpOtp({ phone, token, device_id });
    }
  }

  updateAutoSignupDetails(type) {
    const { otpVerificationForm, otpVerificationForm: { token, device_id }, autoSignUp: _autoSignUp } = this.stateLessKeys;
    otpVerificationForm.data = { ...otpVerificationForm.data, ..._autoSignUp };
    const man_fileds = (type === 'email') ? ['email', 'otp'] : ['otp'];
    if (utils.isFieldRequired(this.validators, man_fileds)) {
      this.setState({ isShowValidation: true });
    } else {
      this.setState({ isShowValidation: false });
      const params = {
        token: {
          token, device_id,
        },
        others: {
          ...otpVerificationForm,
          skipSignup: true,
        },
      };
      if (type === 'email') {
        this.props.onUpdateAutoSignUpPendingDetails({ email: otpVerificationForm.data.email }, params);
      } else {
        this.props.onUpdateAutoSignUpPendingDetails({ phone: otpVerificationForm.data.phone }, params);
      }
    }
  }

  handleAutoSignUpOtpSent() {
    const { response: { token, device_id } } = this.state.otpRequested;
    if (utils.isFieldRequired(this.validators, ['phone'])) {
      this.setState({ isShowValidation: true });
    } else {
      this.setState({ isShowValidation: false });
      const { autoSignUp: { phone } } = this.stateLessKeys;
      this.props.onAutoSignUpMobileOTPSend({ phone }, { token, device_id });
    }
  }

  handleAutosignupDetails(type, value) {
    const { autoSignUp } = this.stateLessKeys;
    autoSignUp[type] = value;
    this.stateLessKeys.autoSignUp = autoSignUp;
    const { autoSignUpDetails } = this.state;
    const data = JSON.parse(JSON.stringify(autoSignUpDetails));
    data[type] = value;
    this.setState({ autoSignUpDetails: data });
  }

  // signUP otp form and post login if otp send then also required
  signUpOtpForm({ response: { token, device_id, user: { phone: mobileNumber } = {} } = {} }, apiResonse, isShowValidation, signUpOtp) {
    this.setState({ showLogin: false });
    this.stateLessKeys.otpVerificationForm = { token, device_id, data: { phone: mobileNumber, client_key: 'client_key', client_version: 'WebBrowser' } };
    return (
      <div className="login_popup">
        <ul>
          <li role="presentation" className="width100">
            <span className="active">Phone Verification</span>
          </li>
        </ul>
        <div>
          <FloatingLabel label="Mobile Number" value={mobileNumber}>
            <Input
              defaultValue={mobileNumber}
              type="text"
              disabled
            />
          </FloatingLabel>
          <FloatingLabel label="Enter OTP" value={signUpOtp}>
            <Input
              type="text"
              // placeholder="Enter OTP"
              onChange={(e) => {
              // this.stateLessKeys.otpVerificationForm.data.otp = utils.onlyNumbers(e.target.value);
                this._updateValidators('otp', utils.onlyNumbers(e.target.value));
                this._onChangeSignUpOtp('otp', utils.onlyNumbers(e.target.value));
              }}
              required
              maxLength={6}
              value={signUpOtp}
            />
            {isShowValidation && ValidationErrors(this.validators, 'otp')}
          </FloatingLabel>
          <Alert {...apiResonse} />
          <Button type="primary" onClick={this.handleVerifyOtp}>Verify OTP</Button>
        </div>
        <span className="links left" role="presentation" onClick={() => { this.resendSignUpOtp(); this.triggerEventTracking('Signup', 'Resend OTP'); }}>Not received OTP? Resend OTP</span>
      </div>
    );
  }

  _onSetPassowrdSubmit() {
    const { isEmailClicked } = this.state;
    const man_fileds = isEmailClicked ? ['email'] : ['phone'];
    if (utils.isFieldRequired(this.validators, man_fileds)) {
      this.setState({ isShowValidation: true });
    } else {
      this.setState({ isShowValidation: false });
      this.triggerEventTracking('Login', 'Set password Submit', isEmailClicked ? 'e-mail' : 'phone');
      this.props.onSetPassowrdSubmit(man_fileds[0]);
    }
  }

  checkCondition() {
    const {
      isForgotPasswordClicked,
      otpSend,
      phoneNumber,
      isEmailClicked,
      otpRequested,
      isShowValidation,
      apiResonse,
      signUpOtp,
    } = this.state;
    const {
      onChangeForgotForm,
      location: {
        pathname,
      },
    } = this.props;
    if (isForgotPasswordClicked) {
      const { otp = '', password = '', confirmPassword = '' } = this.stateLessKeys.forgot_Password; // phone = ''
      return (
        <div className="login_popup">
          <ul>
            <li role="presentation" className="width100">
              <span className="active">Forgot Password</span>
            </li>
          </ul>
          <div>
            {otpSend ? (
              <div>
                <Fragment>
                  <FloatingLabel label="Enter Your Mobile Number" value={phoneNumber}>
                    <Input
                    // onChange={(e) => onChangeForgotForm('phone', e.target.value)}
                      type="text"
                      // placeholder="Enter Your Mobile Number"
                      disabled
                      value={phoneNumber}
                    />
                  </FloatingLabel>
                </Fragment>
                <Fragment>
                  <FloatingLabel label="Enter OTP Received on your phone" value={otp}>
                    <Input
                    // onChange={(e) => onChangeForgotForm('otp', e.target.value)}
                      onChange={(e) => {
                        onChangeForgotForm('otp', utils.onlyNumbers(e.target.value));
                        this.stateLessKeys.forgot_Password.otp = utils.onlyNumbers(e.target.value);
                        this._updateValidators('otp', utils.onlyNumbers(e.target.value));
                      }}
                      type="text"
                      // placeholder="Enter OTP Received on your phone"
                      required
                      key="otp"
                      maxLength={6}
                      value={otp}
                    />
                    {isShowValidation && ValidationErrors(this.validators, 'otp')}
                  </FloatingLabel>
                </Fragment>
                <Fragment>
                  <FloatingLabel label="Enter new Password" value={password}>
                    <Input
                      onChange={(e) => {
                        onChangeForgotForm('password', e.target.value);
                        this.stateLessKeys.forgot_Password.password = e.target.value;
                        this._updateValidators('password', e.target.value);
                      }}
                      type="password"
                      required
                      key="password"
                      maxLength={15}
                      value={password}
                    />
                    {isShowValidation && ValidationErrors(this.validators, 'password')}
                  </FloatingLabel>
                </Fragment>
                <Fragment>
                  <FloatingLabel label="Confirm Password" value={confirmPassword}>
                    <Input
                      onChange={(e) => {
                        onChangeForgotForm('confirmPassword', e.target.value);
                        this.stateLessKeys.forgot_Password.confirmPassword = e.target.value;
                        this._validateCnfrmPass(e.target.value);
                      }}
                      type="password"
                      className="nomargin"
                      required
                      key="confirmpassword"
                      maxLength={15}
                      value={confirmPassword}
                    />
                    {isShowValidation && ValidationErrors(this.validators, 'confirmPassword')}
                  </FloatingLabel>
                </Fragment>
              </div>
            ) : (
              <div>
                <FloatingLabel label="Enter Your Mobile Number" value={phoneNumber}>
                  <Input
                  // onChange={(e) => { onChangeForgotForm('phone', e.target.value); this.storePhoneNumber(e); }}
                    onChange={(e) => {
                      onChangeForgotForm('phone', utils.onlyNumbers(e.target.value));
                      this.storePhoneNumber(e);
                      this.stateLessKeys.forgot_Password.phone = utils.onlyNumbers(e.target.value);
                      this._updateValidators('phone', utils.onlyNumbers(e.target.value));
                    }}
                    type="text"
                    // placeholder="Enter Your Mobile Number"
                    className="nomargin"
                    maxLength={10}
                    value={phoneNumber}
                    required
                    key="phone"
                  />
                  {isShowValidation && ValidationErrors(this.validators, 'phone')}
                </FloatingLabel>
              </div>
            )
            }
            <Alert {...apiResonse} />
            <Button type="primary" block className="margin-t-1" onClick={this._onForgotSubmit}>{otpSend ? ('Change Password') : ('Send OTP')}</Button>
          </div>
          {otpSend && (
            <span className="links left" role="presentation" onClick={() => this.resendOTP()}>Not received OTP? Resend OTP</span>)}
          <span className="links right" role="presentation" onClick={() => this.handleChange('login')}>Back to Login</span>
        </div>);
    }
    if (otpRequested && otpRequested.success) {
      if (otpRequested.type) {
        if (otpRequested.type === 'otp_verification') {
          return this.signUpOtpForm(otpRequested, apiResonse, isShowValidation, signUpOtp);
        }
        return this.renderColectDetailForm(otpRequested, apiResonse, isShowValidation);
      }
      return this.signUpOtpForm(otpRequested, apiResonse, isShowValidation, signUpOtp);
    }
    const { onChangeSetPasswordForm } = this.props;
    const { phone = '', email = '' } = this.stateLessKeys.set_Password;
    return (
      <div className="login_popup">
        <ul>
          <li role="presentation" className="width100">
            <span className="active">Set Password</span>
          </li>
        </ul>
        <div className="set-pw">
          <Radio id="email" _onEventChange={this.handleChildActions} selectedOption={isEmailClicked ? 'email' : 'phone'} payloadKey="Checkbox">Email
          </Radio>
          <Radio id="phone" _onEventChange={this.handleChildActions} selectedOption={isEmailClicked ? 'email' : 'phone'} payloadKey="Checkbox">Phone
          </Radio>
          {
            isEmailClicked ?
              <Fragment>
                <Input
                  key="email"
                  type="email"
                  placeholder="Enter Email"
                  onChange={(e) => {
                    onChangeSetPasswordForm('email', e.target.value);
                    this.stateLessKeys.set_Password.email = e.target.value;
                    this._updateValidators('email', e.target.value);
                  }}
                  value={email}
                />
                {isShowValidation && ValidationErrors(this.validators, 'email')}
              </Fragment> :
              <Fragment>
                <Input
                  type="text"
                  key="phone"
                  placeholder="Enter Mobile Number"
                  onChange={(e) => {
                    onChangeSetPasswordForm('phone', utils.onlyNumbers(e.target.value));
                    this.stateLessKeys.set_Password.phone = utils.onlyNumbers(e.target.value);
                    this._updateValidators('phone', utils.onlyNumbers(e.target.value));
                  }}
                  maxLength={10}
                  value={phone}
                />
                {isShowValidation && ValidationErrors(this.validators, 'phone')}
              </Fragment>
          }
          <Alert {...apiResonse} />
          <Button type="primary" block className="margin-t-1" onClick={this._onSetPassowrdSubmit}>Submit</Button>
        </div>
        { (pathname === constants.LINK_PROPEL_CORPORATE_GIFITING_HOME || pathname === constants.LYRA_PG_LOGIN) ? (<span className="links right" role="presentation" onClick={() => this.handleChange('login')}>Back to Login</span>) :
          (<span className="links left" role="presentation" onClick={() => this.handleChange('signup')}>New User? Signup here</span>) }
      </div>);
  }

  _updateValidators(type, value) {
    const { forgot_Password: { password } } = this.stateLessKeys;
    if (type === 'confirmPassword') {
      this.validators = utils.updateValidators(this.validators, type, value, { password });
    } else {
      this.validators = utils.updateValidators(this.validators, type, value);
    }
  }

  _validateCnfrmPass(value) {
    const formData = this.props.forgotForm;
    if (utils.isEqual(formData.password, value)) {
      this._updateValidators('confirmPassword', value);
    } else {
      this._updateValidators('confirmPassword', '');
    }
  }

  _onSignUp() {
    if (utils.isFieldRequired(this.validators, MANDATORYFIELDS_SIGNUP)) {
      this.setState({ isShowValidation: true });
    } else {
      const { history: { location: { pathname } = {} }, onSignUp } = this.props;
      this.setState({ isShowValidation: false });
      onSignUp({ pathname });
    }
  }

  /**
   * @description login will not be passed with any validator
   */
  _onLogin() {
    const {
      isLoaderRequired,
      onLogin,
      form: {
        validateFields,
      },
    } = this.props;
    const { captchaKey } = this.state;
    validateFields((err) => {
      if (!err && !captchaKey) {
        onLogin({ isLoaderRequired, g_recaptcha_response_data: captchaKey });
      } else if (!captchaKey) {
        this._updateValidators('recaptcha', '', '', 'Please verify the Recaptcha');
        this.setState({ isShowValidationRecaptcha: true });
      }
    });
  }

  _onChangeSignUpOtp(type, value) {
    this.setState({ signUpOtp: value });
  }

  triggerEventTracking(Category, actionType, label) {
    const { history: { location: { pathname } = {} } } = this.props;
    const pageName = (label && label === 'pageName' ? pathname : null);
    eventTracking.triggerEvent(Category, actionType, pageName);
  }

  /**
   * @todo move @func onChangeLoginForm to seperate @function
   */
  renderColectDetailForm({ response: { token, device_id, user: { phone: mobileNumber } = {} } = {}, type, otpSent = false, phone = '' }, apiResonse, isShowValidation) {
    this.stateLessKeys.otpVerificationForm = { token, device_id, data: { phone: mobileNumber, client_key: 'client_key', client_version: 'WebBrowser' } };
    const { autoSignUpDetails: { email = '', otp = '' } } = this.state;
    if (type === 'email_verification') {
      return (
        <div className="login_popup">
          <ul>
            <li role="presentation" className="width100">
              <span className="active">Email Verification</span>
            </li>
          </ul>
          <FloatingLabel label="Enter your email address" value={email}>
            <div>
              <Input
                type="email"
                onChange={(e) => {
                // this.stateLessKeys.otpVerificationForm.data.email = e.target.value;
                // this.stateLessKeys.otpVerificationForm.data.pendingAction = 'email_update';
                  this.handleAutosignupDetails('email', e.target.value);
                  this._updateValidators('email', e.target.value);
                }}
                required
                value={email}
              />
              {isShowValidation && ValidationErrors(this.validators, 'email')}
            </div>
          </FloatingLabel>
          <div>
            <FloatingLabel label="Mobile Number" value={mobileNumber}>
              <Input
                defaultValue={mobileNumber}
                type="text"
                placeholder="Mobile Number"
                disabled
              />
            </FloatingLabel>
            <FloatingLabel label="Enter OTP" value={otp}>
              <Input
                type="password"
                onChange={(e) => {
                  this.handleAutosignupDetails('otp', utils.onlyNumbers(e.target.value));
                  this._updateValidators('otp', utils.onlyNumbers(e.target.value));
                }}
                required
                maxLength={6}
                value={otp}
              />
              {isShowValidation && ValidationErrors(this.validators, 'otp')}
            </FloatingLabel>
            <Alert {...apiResonse} />
            <Button type="primary" onClick={() => this.updateAutoSignupDetails('email')}>Verify OTP</Button>
          </div>
          <span className="links left" role="presentation" onClick={() => this.resendSignUpOtp()}>Not received OTP? Resend OTP</span>
        </div>
      );
    }
    return (
      <div className="login_popup">
        <ul>
          <li role="presentation" className="width100">
            <span className="active">Phone Number Verification</span>
          </li>
        </ul>
        <div>
          {
            otpSent ? (
              <div>
                <FloatingLabel label="Mobile Number" value={phone}>
                  <Input
                    defaultValue={phone}
                    type="text"
                    disabled
                  />
                </FloatingLabel>
                <FloatingLabel label="Enter OTP" value={otp}>
                  <Input
                    type="password"
                    // placeholder="Enter OTP"
                    onChange={(e) => {
                      this.handleAutosignupDetails('otp', utils.onlyNumbers(e.target.value));
                      this._updateValidators('otp', utils.onlyNumbers(e.target.value));
                    }}
                    required
                    maxLength={6}
                    value={otp}
                  />
                  {isShowValidation && ValidationErrors(this.validators, 'otp')}
                </FloatingLabel>
                <Alert {...apiResonse} />
                <Button type="primary" onClick={() => this.updateAutoSignupDetails('phone')}>Verify OTP</Button>
                <span className="links left" role="presentation" onClick={() => this.resendSignUpOtp('autoSignUp')}>Not received OTP? Resend OTP</span>
              </div>
            ) : (
              <FloatingLabel label="Enter your Phone number"> {/* To Do Vishwadeep Kapoor */}
                <div>
                  <Input
                    type="text"
                    onChange={(e) => {
                      this.handleAutosignupDetails('phone', utils.onlyNumbers(e.target.value));
                      this._updateValidators('phone', utils.onlyNumbers(e.target.value));
                    }}
                    required
                    maxLength={10}
                  />
                  {isShowValidation && ValidationErrors(this.validators, 'phone')}
                  <Alert {...apiResonse} />
                  <Button type="primary" onClick={() => this.handleAutoSignUpOtpSent()}>Send OTP</Button>
                </div>
              </FloatingLabel>
            )
          }
        </div>
      </div>
    );
  }

  renderLoginForm() {
    const {
      loginForm: {
        username,
        password,
      } = {},
      onChangeLoginForm,
      form: {
        getFieldDecorator,
      },
      location: { pathname = '' } = {},
    } = this.props;
    const {
      apiResonse,
      isShowValidationRecaptcha,
    } = this.state;
    return (
      <div key="loginForm">
        <FloatingLabel label="Email or Mobile Number" value={username}>
          <Form.Item>
            {getFieldDecorator('username', {
              rules: [validationRules.email_or_mobile],
              initialValue: username,
            })(
              <div className="form-element">
                <Input
                  onChange={({ target: { value } }) => onChangeLoginForm('username', value)}
                  id="username"
                  type="text"
                />
              </div>)}
          </Form.Item>
        </FloatingLabel>

        <FloatingLabel label="Password" value={password}>
          <Form.Item>
            {getFieldDecorator('password', {
              rules: [validationRules.mandatory],
              initialValue: password,
            })(
              <div className="form-element">
                <Input.Password
                  onChange={({ target: { value } }) => {
                    onChangeLoginForm('password', value);
                  }}
                  id="password"
                  type="password"
                  className="nomargin"
                />
              </div>)}
          </Form.Item>
        </FloatingLabel>
        {/* <RecaptchaWrapper onRecaptchaValidation={this.onRecaptchaValidation} /> */}
        {isShowValidationRecaptcha && ValidationErrors(this.validators, 'recaptcha')}
        <Button type="primary" className="margin-t-1 margin-b-1" block onClick={this._onLogin}>Login</Button>
        <span role="presentation" className="links left hand-cursor" onClick={() => { this.handleChange('forgot_pass'); this.triggerEventTracking('Login', 'Forgot Password', 'pageName'); }}>Forgot Password ?</span>
        { pathname !== constants.LYRA_PG_LOGIN && <span role="presentation" className="links right hand-cursor" onClick={() => { this.handleChange('set_pass'); this.triggerEventTracking('Login', 'Set password', 'pageName'); }}>Set Password</span> }
        <Alert {...apiResonse} />
      </div>
    );
  }

  /**
   * @todo can move this login and signup to a util
   */
  renderSignUpForm() {
    const { isShowValidation, apiResonse } = this.state;
    const { signUpform: { name = '', phone = '', email = undefined, password = undefined }, onChangeSignUpForm } = this.props;
    return (
      <div key="signupForm">
        <FloatingLabel label="Name" value={name}>
          <div className="form-element">
            <Input
              onChange={(evt) => {
                onChangeSignUpForm('name', utils.onlyStrings(evt.target.value));
                this._updateValidators('name', utils.onlyStrings(evt.target.value));
              }}
              type="text"
              // placeholder="Name"
              required
              value={name}
              maxLength={30}
              key="signup_name"
            />
            {isShowValidation && ValidationErrors(this.validators, 'name')}
          </div>
        </FloatingLabel>
        <FloatingLabel label="Email" value={email}>
          <div className="form-element">
            <Input
              onChange={(evt) => {
                onChangeSignUpForm('email', evt.target.value);
                this._updateValidators('email', evt.target.value);
              }}
              type="email"
              key="signup_email"
              required
            />
            {isShowValidation && ValidationErrors(this.validators, 'email')}
          </div>
        </FloatingLabel>
        <FloatingLabel label="Phone" value={phone}>
          <div className="form-element">
            <Input
              onChange={(evt) => {
                onChangeSignUpForm('phone', utils.onlyNumbers(evt.target.value));
                this._updateValidators('phone', utils.onlyNumbers(evt.target.value));
              }}
              type="text"
              // placeholder="Phone"
              required
              maxLength={10}
              value={phone}
              key="signup_phone"
            />
            {isShowValidation && ValidationErrors(this.validators, 'phone')}
          </div>
        </FloatingLabel>
        <FloatingLabel label="Password" value={password}>
          <div className="form-element">
            <Input.Password
              onChange={(evt) => {
                onChangeSignUpForm('password', evt.target.value);
                this._updateValidators('password', evt.target.value);
              }}
              type="password"
              className="nomargin"
              maxLength={15}
              required
            />
            {isShowValidation && ValidationErrors(this.validators, 'password')}
          </div>
        </FloatingLabel>
        <Alert {...apiResonse} />
        <span className="font-12">
          By clicking on Sign Up, you agree to our &nbsp;
          <Link to={constants.LINK_TERMS_CONDITIONS} className="links" target="_blank">
            T&C
          </Link> &nbsp;and&nbsp;
          <Link to={constants.LINK_PRIVACY_POLICY} className="links" target="_blank">
          &nbsp;Privacy Policy
          </Link>
        </span>


        <Button type="primary" block onClick={this._onSignUp} className="margin-t-1 margin-b-1">Sign Up</Button>
        <span className="links left manage" role="presentation" onClick={() => this.handleChange('login')}>Already a User? Login here</span>
      </div>
    );
  }

  render() {
    const { isLoginClicked, showLogin } = this.state;
    const {
      location: {
        pathname = '',
      } = {},
    } = this.props;
    return (
      <StyledLogin>
        {
          showLogin ? (
            <div className="login_popup">
              <ul>
                <li className={pathname === constants.LYRA_PG_LOGIN ? 'width100' : ''} onClick={() => { this.onTabClick('login'); this.triggerEventTracking('Login', 'Login Click', 'pageName'); }} role="presentation">
                  <span className={isLoginClicked ? 'active' : ''}>Login</span>
                </li>
                {(pathname !== constants.LINK_PROPEL_CORPORATE_GIFITING_HOME && pathname !== constants.LYRA_PG_LOGIN) &&
                <li onClick={() => { this.onTabClick('signup'); this.triggerEventTracking('Signup', 'Signup Click', 'pageName'); }} role="presentation">
                  <span className={!isLoginClicked ? 'active' : ''}>Sign Up</span>
                </li>}
              </ul>
              {isLoginClicked ? this.renderLoginForm(this.props) : this.renderSignUpForm(this.props)}
            </div>
          ) : (
            this.checkCondition()
          )
        }
      </StyledLogin>
    );
  }
}

LoginPage.propTypes = {
  isLoaderRequired: bool,
  isOtpSent: bool.isRequired,
  isSetPasswordSubmit: bool.isRequired,
  isOtpSubmit: bool.isRequired,
  onChangeSignUpForm: func.isRequired,
  onSignUp: func.isRequired,
  onLogin: func.isRequired,
  isShowLogin: bool,
  loginForm: shape({
    username: string,
    password: string,
  }),
  location: shape({}).isRequired,
  onChangeLoginForm: func.isRequired,
  onChangeForgotForm: func.isRequired,
  onChangeSetPasswordForm: func.isRequired,
  onSetPassowrdSubmit: func.isRequired,
  otpRequested: shape({}).isRequired,
  onSignUpOtpSubmitForm: func.isRequired,
  apiResonse: shape({}),
  forgotSubmit: func.isRequired,
  onReSendSignUpOtp: func.isRequired,
  signUpform: shape({}),
  forgotForm: shape({}).isRequired,
  onUpdateAutoSignUpPendingDetails: func.isRequired,
  onAutoSignUpMobileOTPSend: func.isRequired,
  history: shape({}).isRequired,
  form: func.isRequired,
};
LoginPage.defaultProps = {
  isLoaderRequired: false,
  isShowLogin: false,
  apiResonse: {},
  loginForm: {},
  signUpform: {},
};

const mapDispatchToProps = (dispatch) => ({
  onLogin: (payload) => dispatch(login(payload)),
  onSignUp: (payload) => dispatch(signUp(payload)),
  onSetPassowrdSubmit: (type) => dispatch(setPasswordSubmit(type)),
  forgotSubmit: (props) => dispatch(forgotSubmit(props)),
  onChangeLoginForm: (prop, value) => dispatch(changeLoginForm(prop, value)),
  onChangeSignUpForm: (prop, value) => dispatch(changeSignUpForm(prop, value)),
  onChangeForgotForm: (prop, value) => dispatch(changeForgotForm(prop, value)),
  onChangeSetPasswordForm: (prop, value) => dispatch(changeSetPasswordForm(prop, value)),
  onSignUpOtpSubmitForm: (payload) => dispatch(signUpOtpSubmitForm(payload)),
  onReSendSignUpOtp: (payload) => dispatch(sendSignUpOtp(payload)),
  onUpdateAutoSignUpPendingDetails: (payload, otherParams) => dispatch(saveProfileChange(payload, otherParams)),
  onAutoSignUpMobileOTPSend: (payload, otherParams = {}) => dispatch(verifyUserMobileNumber(payload, otherParams)),
});

const mapStateToProps = createStructuredSelector({
  isLoggedIn: selectLoggedIn(),
  loginForm: selectLoginForm(),
  isOtpSent: selectOtpSent(),
  isOtpSubmit: selectOtpSubmit(),
  isSetPasswordSubmit: selectSetPasswordSubmit(),
  otpRequested: selectIsOtpRequested(),
  signUpform: select_LoginJS('signUpform'),
  forgotForm: select_LoginJS('forgotForm'),
});

const LoginPageWrapper = Form.create({ name: 'login_page' })(withRouter(LoginPage));
const component = connect(mapStateToProps, mapDispatchToProps)(LoginPageWrapper);

export { LoginPage, mapDispatchToProps, mapStateToProps };
export default component;



// WEBPACK FOOTER //
// client/containers/LoginPage/index.js